// extracted by mini-css-extract-plugin
export default {"self":"DonateLayout-module--self--B4s3K","annotation":"DonateLayout-module--annotation--anhsi"};